module.exports = __webpack_public_path__ + "img/top-list-left2.893c0636.png";